module.exports = __webpack_public_path__ + "img/cart.520b86cf.svg";